export default function BoringSkills() {
    return (
        <div className="skills-container">
		<img 
		src="https://static.vecteezy.com/system/resources/previews/027/127/587/original/javascript-logo-javascript-icon-transparent-free-png.png" 
		alt="js-logo"
		style={{width: "300px"}}
		/>
            Javascript, Express.js, React, Redux, Solid.js, Python, Flask, SqlAlchemy, Alembic, Go, Gorm, Gin
        </div>
    )
}
